// extracted by mini-css-extract-plugin
export var avatar = "tags-module--avatar--6a149";